// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"40":"50be90ba06c84face131","649":"fd88e4539087cddc18db","904":"2d9d13d84e7973c9bd08"}[chunkId] + ".js";
};